/* The church's Group URL — the last part of its signup link.
 *
 * Same rules as the server's check_slug, so a mistake shows under the field
 * instead of after Save. The server checks again and is the one that knows
 * whether another church already has it. */

/** A church name as a slug, for the Group URL field to start from. */
export function slugify(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60)
      .replace(/-+$/, '') || ''
  )
}

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
const RESERVED = new Set(['churches', 'invite'])

/** What is wrong with it, or null when it is fine. */
export function slugProblem(slug: string): string | null {
  const s = slug.trim().toLowerCase()
  if (!s) return null
  if (s.length < 3 || s.length > 60 || !SLUG_RE.test(s)) {
    return 'Use lowercase letters, numbers and hyphens, 3 to 60 characters, without a hyphen at either end.'
  }
  if (RESERVED.has(s)) return 'That Group URL is reserved. Please choose another.'
  return null
}
